/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveGrantRequestBody
 */
export interface ApproveGrantRequestBody {
    /**
     * The user ID of the child user who proposed the manager (grantor)
     * @type {string}
     * @memberof ApproveGrantRequestBody
     */
    grantorUserId: string;
}

/**
 * Check if a given object implements the ApproveGrantRequestBody interface.
 */
export function instanceOfApproveGrantRequestBody(value: object): value is ApproveGrantRequestBody {
    let isInstance = true;
    isInstance = isInstance && "grantorUserId" in value && value["grantorUserId"] !== undefined;

    return isInstance;
}

export function ApproveGrantRequestBodyFromJSON(json: any): ApproveGrantRequestBody {
    return ApproveGrantRequestBodyFromJSONTyped(json, false);
}

export function ApproveGrantRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveGrantRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grantorUserId': json['grantor_user_id'],
    };
}

export function ApproveGrantRequestBodyToJSON(value?: ApproveGrantRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'grantor_user_id': value.grantorUserId,
    };
}

